import { render, staticRenderFns } from "./AdminUserTicketsInterface.vue?vue&type=template&id=6bc594dc&scoped=true"
import script from "./AdminUserTicketsInterface.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminUserTicketsInterface.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AdminUserTicketsInterface.vue?vue&type=style&index=0&id=6bc594dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc594dc",
  null
  
)

export default component.exports